module.exports = __webpack_public_path__ + "img/magnifying-glass-minus.1c7a6ed2.svg";